export const NONE_ID = 179; // default None
export const PAYPAL_ID = 180; // paypal id

export const GATEWAYS = [
    {
        value: 'none',
        key: 179,
        text: 'None',
        template: 'payment/none.html',
        fields: [],
    },
    {
        value: 'authorize',
        key: 173,
        text: 'Authorize.Net',
        template: 'payment/authorize.html',
        fields: ['authnet_login_id'],
    },
    {
        value: 'quantum',
        key: 175,
        text: 'Quantum',
        template: 'payment/quantum.html',
        fields: ['quantum_login'],
    },
    {
        value: 'beanstream',
        key: 176,
        text: 'Bambora',
        template: 'payment/beanstream.html',
        fields: ['beanstream_pass_code'],
    },
    {
        value: 'paypal',
        key: 180,
        text: 'PayPal',
        template: 'payment/paypal.html',
        fields: ['paypal_email'],
        mappingFields: {
            paypal_auto_approve_payments: function(value) {
                if (value == 'True') {
                    return true;
                } else {
                    return false;
                }
            },
        },
        defaultValues: {
            paypal_details:
                'You will be now taken to the PayPal website to complete your payment. Once your ' +
                'payment is complete, please wait for confirmation from the property owner that ' +
                'your reservation has been approved and payment accepted. Thanks!',
        },
    },
    {
        value: 'payleap',
        key: 218,
        text: 'PayLeap',
        template: 'payment/payleap.html',
        fields: ['payleap_login', 'payleap_vendor'],
    },
    {
        value: 'stripe',
        key: 2056,
        text: 'Stripe',
        template: 'payment/stripe.html',
        fields: ['stripe_gateway_credentials'],
    },
];

export const CREDIT_CART_TYPES = {
    AMERICANEXPRESS: {
        id: 'payment-american-express',
        logo: '/static/images/billing/amex.svg',
    },
    DINERSCLUB: {
        id: 'payment-dinersclub',
        logo: '/static/images/billing/diners.svg',
    },
    DISCOVER: {
        id: 'payment-discover',
        logo: '/static/images/billing/discover.svg',
    },
    MASTERCARD: {
        id: 'payment-mastercard',
        logo: '/static/images/billing/mastercard.svg',
    },
    VISA: {
        id: 'payment-visa',
        logo: '/static/images/billing/visa.svg',
    },
};
